export default {
  data() {
    return {
      statisticalDiagnosis: [
        'Sano',
        'Estrabismo',
        'Cataratas',
        'Glaucoma',
        'Retinopatía diabética',
        'Otros',
      ],
      options: {
        eyelids: [
          {
            value: 'Sin Padecimientos',
            label: 'Sin Padecimientos',
          },
          {
            value: 'No Valorable',
            label: 'No Valorable',
          },
          {
            value: 'Escamas Pestañas',
            label: 'Escamas Pestañas',
          },
          {
            value: 'Secreción Mucos',
            label: 'Secreción Mucosa',
          },
          {
            value: 'Ptosis',
            label: 'Ptosis',
          },
          {
            value: 'Ectropion',
            label: 'Ectropion',
          },
          {
            value: 'Chalazion',
            label: 'Chalazion',
          },
          {
            value: 'Orzuelo',
            label: 'Orzuelo',
          },
          {
            value: 'Distriquiasis',
            label: 'Distriquiasis',
          },
          {
            value: 'Simbléfaron',
            label: 'Simbléfaron',
          },
          {
            value: 'Otro',
            label: 'Otro',
          },
        ],
        annexes: [
          {
            value: 'Sin Padecimientos',
            label: 'Sin Padecimientos',
          },
          {
            value: 'No Valorable',
            label: 'No Valorable',
          },
          {
            value: 'Epífora',
            label: 'Epífora',
          },
          {
            value: 'Oclusión de Punto Lagrimal',
            label: 'Oclusión de Punto Lagrimal',
          },
          {
            value: 'Tubo de Vía Lagrimal',
            label: 'Tubo de Vía Lagrimal',
          },
          {
            value: 'Herida de Punto Lagrimal',
            label: 'Herida de Punto Lagrimal',
          },
          {
            value: 'Otro',
            label: 'Otro',
          },
        ],
        ocularGlobule: [
          {
            value: 'Sin Padecimientos',
            label: 'Sin Padecimientos',
          },
          {
            value: 'No Valorable',
            label: 'No Valorable',
          },
          {
            value: 'Anoftalmos',
            label: 'Anoftalmos',
          },
          {
            value: 'Protesis',
            label: 'Prótesis',
          },
          {
            value: 'Exposición de Puntos',
            label: 'Exposición de Puntos',
          },
          {
            value: 'Phtisis Bulbi',
            label: 'Phtisis Bulbi',
          },
          {
            value: 'Otro',
            label: 'Otro',
          },
        ],
        ocularMotility: [
          {
            value: 'Sin Padecimientos',
            label: 'Sin Padecimientos',
          },
          {
            value: 'No Valorable',
            label: 'No Valorable',
          },
          {
            value: 'Ortoposición PPM',
            label: 'Ortoposición PPM',
          },
          {
            value: 'Endotropía',
            label: 'Endotropía',
          },
          {
            value: 'Exotropía',
            label: 'Exotropía',
          },
          {
            value: 'Hipertropia',
            label: 'Hipertropia',
          },
          {
            value: 'Hipotropia',
            label: 'Hipotropia',
          },
          {
            value: 'Otro',
            label: 'Otro',
          },
        ],
        conjunctiva: [
          {
            value: 'Sin Padecimientos',
            label: 'Sin Padecimientos',
          },
          {
            value: 'No Valorable',
            label: 'No Valorable',
          },
          {
            value: 'Hiperemia',
            label: 'Hiperemia',
          },
          {
            value: 'Puntos Expuestos',
            label: 'Puntos Expuestos',
          },
          {
            value: 'Herida Conjuntival',
            label: 'Herida Conjuntival',
          },
          {
            value: 'Reaccion Papilar',
            label: 'Reaccion Papilar',
          },
          {
            value: 'Reacción Folicular',
            label: 'Reacción Folicular',
          },
          {
            value: 'Otro',
            label: 'Otro',
          },
        ],
        sclera: [
          {
            label: '',
            key: 'sclera',
            ops: [
              {
                value: 'Sin Padecimientos',
                label: 'Sin Padecimientos',
              },
              {
                value: 'No Valorable',
                label: 'No Valorable',
              },
              {
                value: 'Integra',
                label: 'Integra',
              },
              {
                value: 'Epiescleritis',
                label: 'Epiescleritis',
              },
              {
                value: 'Escleritis',
                label: 'Escleritis',
              },
              {
                value: 'Herida Escleral',
                label: 'Herida Escleral',
              },
              {
                value: 'Dellen',
                label: 'Dellen',
              },
              {
                value: 'Otro',
                label: 'Otro',
              },
            ],
          },
          {
            label: 'Adelgazamiento',
            key: 'esclera thinning',
            ops: [
              {
                value: 'Adelgazamiento Con Exposición Uveal',
                label: 'Con Exposición Uveal',
              },
              {
                value: 'Adelgazamiento Sin Exposición Uveal',
                label: 'Sin Exposición Uveal',
              },
            ],
          },
        ],
        cornea: [
          {
            label: '',
            key: 'cornea',
            ops: [
              {
                value: 'Sin Padecimientos',
                label: 'Sin Padecimientos',
              },
              {
                value: 'No Valorable',
                label: 'No Valorable',
              },
              {
                value: 'Transparente',
                label: 'Transparente',
              },
              {
                value: 'Gutatta/Fuchs',
                label: 'Gutatta/Fuchs',
              },
              {
                value: 'Queratopatía Bulosa Pseudofaquica',
                label: 'Queratopatía Bulosa Pseudofaquica',
              },
              {
                value: 'Depósitos Retroqueráticos',
                label: 'Depósitos Retroqueráticos',
              },
              {
                value: 'Pigmentos',
                label: 'Pigmentos',
              },
              {
                value: 'Distrofia',
                label: 'Distrofia',
              },
              {
                value: 'Otro',
                label: 'Otro',
              },
            ],
          },
          {
            label: 'Herida',
            key: 'cornea wound',
            ops: [
              {
                value: 'Herida Perforante',
                label: 'Perforante',
              },
              {
                value: 'Herida No Perforante',
                label: 'No Perforante',
              },
            ],
          },
          {
            label: 'Úlcera Corneal',
            key: 'cornea ulcer',
            ops: [
              {
                value: 'Úlcera Perforante',
                label: 'Perforante',
              },
              {
                value: 'Úlcera No Perforante',
                label: 'No Perforante',
              },
            ],
          },
          {
            label: 'Adelgazamiento',
            key: 'cornea thinning',
            ops: [
              {
                value: 'Adelgazamiento Perforante',
                label: 'Perforante',
              },
              {
                value: 'Adelgazamiento No Perforante',
                label: 'No Perforante',
              },
            ],
          },
          {
            label: 'Queratocono',
            key: 'cornea queratocono',
            ops: [
              {
                value: 'Queratocono Queratocono',
                label: 'Queratocono',
              },
              {
                value: 'Queratocono Hidrops',
                label: 'Hidrops',
              },
            ],
          },
        ],
        anteriorChamber: [
          {
            label: '',
            key: 'sfpa',
            ops: [
              {
                value: 'Sin Padecimientos',
                label: 'Sin Padecimientos',
              },
              {
                value: 'No Valorable',
                label: 'No Valorable',
              },
              {
                value: 'Formada',
                label: 'Formada',
              },
              {
                value: 'Plana',
                label: 'Plana',
              },
              {
                value: 'Atalamía',
                label: 'Atalamía',
              },
              {
                value: 'Otro',
                label: 'Otro',
              },
            ],
          },
          {
            label: 'Celularidad',
            key: 'anterior chamber celullarity',
            ops: [
              {
                value: 'Celularidad +1',
                label: '+1',
              },
              {
                value: 'Celularidad +2',
                label: '+2',
              },
              {
                value: 'Celularidad +3',
                label: '+3',
              },
              {
                value: 'Celularidad +4 Flare',
                label: '+4 Flare',
              },
            ],
          },
          {
            label: 'Hiphema',
            key: 'anterior chamber hiphema',
            ops: [
              {
                value: 'Hiphema +1',
                label: '+1',
              },
              {
                value: 'Hiphema +2',
                label: '+2',
              },
              {
                value: 'Hiphema +3',
                label: '+3',
              },
              {
                value: 'Hiphema Bola 8',
                label: 'Bola 8',
              },
            ],
          },
        ],
        iris: [
          {
            value: 'Sin Padecimientos',
            label: 'Sin Padecimientos',
          },
          {
            value: 'No Valorable',
            label: 'No Valorable',
          },
          {
            value: 'Reflejos Presentes',
            label: 'Reflejos Presentes',
          },
          {
            value: 'Midriasis Farmacológica',
            label: 'Midriasis Farmacológica',
          },
          {
            value: 'Asimetría',
            label: 'Asimetría',
          },
          {
            value: 'Rubeosis Iridis',
            label: 'Rubeosis Iridis',
          },
          {
            value: 'Aniridia',
            label: 'Aniridia',
          },
          {
            value: 'Atrófico',
            label: 'Atrófico',
          },
          {
            value: 'Otro',
            label: 'Otro',
          },
        ],
        ginioscopy: [
          {
            value: 'No Valorable',
            label: 'No Valorable',
          },
          {
            value: 'Diferido',
            label: 'Diferido',
          },
          {
            value: 'Abierto',
            label: 'Abierto',
          },
          {
            value: 'Cerrado',
            label: 'Cerrado',
          },
          {
            value: 'Otro',
            label: 'Otro',
          },
        ],
        lens: [
          {
            label: '',
            key: ' lens',
            ops: [
              {
                value: 'No Valorable',
                label: 'No Valorable',
              },
              {
                value: 'Transparente',
                label: 'Transparente',
              },
              {
                value: 'Lente Intraocular',
                label: 'Lente Intraocular',
              },
              {
                value: 'Afaquia',
                label: 'Afaquia',
              },
              {
                value: 'Otro',
                label: 'Otro',
              },
            ],
          },
          {
            label: 'Catarata senil',
            key: 'lens cataracts senil',
            ops: [
              {
                value: 'Catarata Senil LOCS III',
                label: 'LOCS III',
              },
              {
                value: 'Catarata Senil Madura',
                label: 'Madura',
              },
              {
                value: 'Catarata Senil Brunescente',
                label: 'Brunescente',
              },
            ],
          },
          {
            label: 'Catarata Traumática',
            key: 'lens cataracts traumatic',
            ops: [
              {
                value: 'Catarata Traumática Cápsula Integra',
                label: 'Cápsula Integra',
              },
              {
                value: 'Catarata Traumática Cápsula Rota',
                label: 'Cápsula Rota',
              },
            ],
          },
        ],
        retina: [
          {
            value: 'Sin alteraciones',
            label: 'Sin alteraciones',
          },
          {
            value: 'No Valorable',
            label: 'No Valorable',
          },
          {
            value: 'No Valorable por Medios Opacos',
            label: 'No Valorable por Medios Opacos',
          },
          {
            value: 'Desprendimiento Traccional',
            label: 'Desprendimiento Traccional',
          },
          {
            value: 'Desprendimiento Seroso',
            label: 'Desprendimiento Seroso',
          },
          {
            value: 'Desprendimiento Regmatógeno',
            label: 'Desprendimiento Regmatógeno',
          },
          {
            value: 'Otro',
            label: 'Otro',
          },
        ],
        vitreo: [
          {
            label: '',
            key: 'tdfhs',
            ops: [
              {
                value: 'No Valorable',
                label: 'No Valorable',
              },
              {
                value: 'Transparente',
                label: 'Transparente',
              },
              {
                value: 'Desprendimiento',
                label: 'Desprendimiento',
              },
              {
                value: 'Flotadores',
                label: 'Flotadores',
              },
              {
                value: 'Hialosis Asteroidea',
                label: 'Hialosis Asteroidea',
              },
              {
                value: 'Sinquisis Centellante',
                label: 'Sinquisis Centellante',
              },
              {
                value: 'Bancos de Nieve',
                label: 'Bancos de Nieve',
              },
              {
                value: 'Condensaciones Vítreas',
                label: 'Condensaciones Vítreas',
              },
              {
                value: 'Turbio',
                label: 'Turbio',
              },
              {
                value: 'Aceite de Silicón',
                label: 'Aceite de Silicón',
              },
              {
                value: 'Gas en Cavidad Vitrea',
                label: 'Gas en Cavidad Vitrea',
              },
              {
                value: 'Aire en Cavidad Vitrea',
                label: 'Aire en Cavidad Vitrea',
              },
              {
                value: 'Otro',
                label: 'Otro',
              },
            ],
          },
          {
            label: 'Hemovitreo',
            key: 'vitreo hemovitreo',
            ops: [
              {
                value: 'No Valorable',
                label: 'No Valorable',
              },
              {
                value: 'Hemovitreo Grado 1',
                label: 'Grado 1',
              },
              {
                value: 'Hemovitreo Grado 2',
                label: 'Grado 2',
              },
              {
                value: 'Hemovitreo Grado 3',
                label: 'Grado 3',
              },
              {
                value: 'Hemovitreo Grado 4',
                label: 'Grado 4',
              },
            ],
          },
          {
            label: '',
            key: 'hs',
            ops: [
              {
                value: 'Hemorragia Subhialoidea',
                label: 'Hemorragia Subhialoidea',
              },
            ],
          },
        ],
        cupDisk: [
          {
            value: '1',
            label: '0.1',
          },
          {
            value: '2',
            label: '0.2',
          },
          {
            value: '3',
            label: '0.3',
          },
          {
            value: '4',
            label: '1.0',
          },
          {
            value: 'Otro',
            label: 'Otro',
          },
        ],
        nerve: [
          {
            value: 'Sin Padecimientos',
            label: 'Sin Alteraciones',
          },
          {
            value: 'No Valorable',
            label: 'No Valorable',
          },
          {
            value: 'Pálido',
            label: 'Pálido',
          },
          {
            value: 'Excavación Total',
            label: 'Excavación Total',
          },
          {
            value: 'Papilitis',
            label: 'Papilitis',
          },
          {
            value: 'Papiledema',
            label: 'Papiledema',
          },
          {
            value: 'Neovasos Epipapilares',
            label: 'Neovasos Epipapilares',
          },
          {
            value: 'Otro',
            label: 'Otro',
          },
        ],
        macula: [
          {
            value: 'No Valorable',
            label: 'No Valorable',
          },
          {
            value: 'Brillo Normal',
            label: 'Brillo Normal',
          },
          {
            value: 'Agujero Macular',
            label: 'Agujero Macular',
          },
          {
            value: 'Sin Brillo',
            label: 'Sin Brillo',
          },
          {
            value: 'Membranas',
            label: 'Membranas',
          },
          {
            value: 'Maculopatía',
            label: 'Maculopatía',
          },
          {
            value: 'Maculopatía Serosa',
            label: 'Maculopatía Serosa',
          },
          {
            value: 'Edema Macular',
            label: 'Edema Macular',
          },
          {
            value: 'Exudados',
            label: 'Exudados',
          },
          {
            value: 'Drusas Algodonosas',
            label: 'Drusas Algodonosas',
          },
          {
            value: 'Drusas Secas',
            label: 'Drusas Secas',
          },
          {
            value: 'Cicatriz Macular',
            label: 'Cicatriz Macular',
          },
          {
            value: 'Atrofia',
            label: 'Atrofia',
          },
          {
            value: 'Otro',
            label: 'Otro',
          },
        ],
        vessel: [
          {
            label: '',
            key: 'vn',
            ops: [
              {
                value: 'No Valorable',
                label: 'No Valorable',
              },
              {
                value: 'Vasculatura Normal',
                label: 'Vasculatura Normal',
              },
              {
                value: 'Neovasos',
                label: 'Neovasos',
              },
              {
                value: 'Microaneurismas',
                label: 'Microaneurismas',
              },
              {
                value: 'Vasos Envainados',
                label: 'Vasos Envainados',
              },
              {
                value: 'Cruces AV',
                label: 'Cruces AV',
              },
              {
                value: 'Arrosariamiento Venoso',
                label: 'Arrosariamiento Venoso',
              },
              {
                value: 'Otro',
                label: 'Otro',
              },
            ],
          },
          {
            label: 'Microhemorragias',
            key: 'vessel microhemorrhages grade',
            ops: [
              {
                value: 'Microhemorragias 1/4',
                label: '1/4',
              },
              {
                value: 'Microhemorragias 2/4',
                label: '2/4',
              },
              {
                value: 'Microhemorragias 3/4',
                label: '3/4',
              },
              {
                value: 'Microhemorragias 4/4',
                label: '4/4',
              },
            ],
          },
          {
            label: 'Exudados',
            key: 'vessel exudates grade',
            ops: [
              {
                value: 'Microhemorragias 1/4',
                label: '1/4',
              },
              {
                value: 'Microhemorragias 2/4',
                label: '2/4',
              },
              {
                value: 'Microhemorragias 3/4',
                label: '3/4',
              },
              {
                value: 'Microhemorragias 4/4',
                label: '4/4',
              },
            ],
          },
          {
            label: '',
            key: 'exangues',
            ops: [
              {
                value: 'Exangües',
                label: 'Exangües',
              },
            ],
          },
        ],
        periphery: [
          {
            value: 'No Valorable',
            label: 'No Valorable',
          },
          {
            value: 'Sin Lesiones Predisponentes',
            label: 'Sin Lesiones Predisponentes',
          },
          {
            value: 'Desgarro',
            label: 'Desgarro',
          },
          {
            value: 'Opérculo',
            label: 'Opérculo',
          },
          {
            value: 'Agujero',
            label: 'Agujero',
          },
          {
            value: 'Lattice',
            label: 'Lattice',
          },
          {
            value: 'Huellas de Láser (PFC)',
            label: 'Huellas de Láser (PFC)',
          },
          {
            value: 'Otro',
            label: 'Otro',
          },
        ],
        tf: [
          {
            value: true,
            label: 'Si',
          },
          {
            value: false,
            label: 'No',
          },
        ],
      },
    };
  },
};
